import { selectors } from 'data'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { isEmailVerified } from 'utils/user'

import VerifyEmail from './VerifyEmail'

// Watchs for changes in user (login for example) and triggers verify email flow if not verified yet
const CheckVerifiedEmail = ({ children }) => {
  const user = useSelector(selectors.auth.getUser)
  const [showVerifyEmail, setShowVerifyEmail] = useState(false)
  useEffect(
    function watchUserForKYCEffect() {
      const needsVerication = !!user && !isEmailVerified(user)
      setShowVerifyEmail(needsVerication)
    },
    [user]
  )

  if (showVerifyEmail) {
    return <VerifyEmail onDone={() => setShowVerifyEmail(false)} />
  }

  return children
}

export default CheckVerifiedEmail
